(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockTarifAuswahl', {
            require: {
                form: '^form'
            },
            bindings: {
                bausteinBeitrag: '<abtaBausteinBeitrag',
                bausteinLabel: '<?abtaBausteinLabel',
                changeBaustein: '&?abtaChangeBaustein',
                changeTarifart: '&?abtaChangeTarifart',
                zahlweise: '<abtaZahlweise',
                options: '<abtaOptions',
                disabled: '<abtaDisabled'
            },
            templateUrl: 'bloecke/ergebnis/blockTarifAuswahl.html',
            controller: BlockTarifAuswahlController,
            controllerAs: 'blockTarifAuswahlVm'
        });

    BlockTarifAuswahlController.$inject = [
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'SchluesselWerteUtilsService',
        'BasisAngebotService',
        'TrackingUtilsService'
    ];
    function BlockTarifAuswahlController(_, AppConfig, MiscUtilsService, SchluesselWerteUtilsService, BasisAngebotService, TrackingUtilsService) {
        var vm = this,
            formFieldNames = [
                'auswahl',
                'tarifart'
            ],
            zahlweiseTextMap;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.isButtonPressed = isButtonPressed;
        vm.getButtonLabel = getButtonLabel;
        vm.isTarifartAktiv = isTarifartAktiv;
        vm.getMainCls = getMainCls;
        vm.getTarifartCls = getTarifartCls;
        vm.getButtonCls = getButtonCls;
        vm.onChangeTarifart = onChangeTarifart;
        vm.isTarifartEmpfehlungSichtbar = isTarifartEmpfehlungSichtbar;

        function activate() {
            vm.options = vm.options || {};
            zahlweiseTextMap = AppConfig.ANGEBOT.zahlweiseText;

            vm.gridLayoutCss = vm.options.grid || {};

            vm.label = getLabel();
            vm.tarifartProperty = 'tarifartModellierung';
            vm.moeglicheTarifarten = BasisAngebotService.sortiereTarifarten(_.get(vm.bausteinBeitrag, 'baustein.moeglicheTarifarten', _.map(_.compact(_.split(AppConfig.ANGEBOT.defaultMoeglicheTarifarten, '#')), function (tarifart) {
                return SchluesselWerteUtilsService.create('TARIFART', tarifart, AppConfig.ANGEBOT.tarifarten[tarifart]);
            })));

            vm.hasMehrereTarifarten = _.size(vm.moeglicheTarifarten) > 1;
            vm.changeBausteinVorhanden = _.isFunction(vm.changeBaustein);
            vm.bausteinTarifart = _.get(vm.bausteinBeitrag, 'baustein.' + vm.tarifartProperty);
            vm.zahlweiseText = zahlweiseTextMap[_.get(vm.zahlweise, 'wert') || _.get(vm.bausteinBeitrag, 'beitrag.' + _.get(vm.bausteinTarifart, 'wert') + '.zahlweise.wert')];
            vm.defaultAnzahlMoeglicheTarifarten = _.get(vm.options, 'defaultAnzahlMoeglicheTarifarten') || AppConfig.ANGEBOT.defaultAnzahlMoeglicheTarifarten;
        }

        function onInit() {
            vm.uuid = MiscUtilsService.guid('#');
            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return [
                    _.get(vm.bausteinBeitrag, 'bausteinKey') + _.capitalize(fieldName),
                    vm.uuid
                ].join('_');
            }));

            activate();

            TrackingUtilsService.trackDefaultEvent('button', 'wgv', [{
                name: 'tarifwahl',
                value: _.get(vm.bausteinTarifart, 'wert'),
                state: vm.disabled ? 'unchangeable' : 'default'
            }]);
        }

        function onChanges() {
            activate();
        }

        function isTarifartAktiv(tarifart, baustein) {
            baustein = baustein || _.get(vm.bausteinBeitrag, 'baustein');

            return (
                _.get(baustein, vm.tarifartProperty + '.wert') === tarifart &&
                 _.get(baustein, 'aktiv')
             );
        }
        function getLabel() {
            return {
                deckung: _.get(vm.bausteinLabel, 'deckung') || _.get(vm.bausteinBeitrag, 'infos.label.deckung'),
                deckungEffektiv: _.get(vm.bausteinLabel, 'deckungEffektiv') || _.get(vm.bausteinBeitrag, 'infos.label.deckungEffektiv'),
                zusatz: _.get(vm.bausteinLabel, 'zusatz') || _.get(vm.bausteinBeitrag, 'infos.label.zusatz'),
                zusatzEffektiv: _.get(vm.bausteinLabel, 'zusatzEffektiv') || _.get(vm.bausteinBeitrag, 'infos.label.zusatzEffektiv')
            };
        }

        function isButtonPressed(tarifart) {
            return isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein'));
        }

        function getButtonLabel(tarifart) {
            var beitragTarifart = _.get(vm.bausteinBeitrag, 'beitrag.' + tarifart + '.brutto.amount');

            if (!beitragTarifart || _.toNumber(beitragTarifart) === 0) {
                return 'Berechnen';
            }

            return isButtonPressed(tarifart) ? 'Ausgewählt' : 'Auswählen';
        }

        function getMainCls() {
            var cls = ['row-tarifart-auswahl'];

            if (vm.hasMehrereTarifarten) {
                cls.push('mehrere-tarifarten');
                cls.push('tarifarten-' + _.size(vm.moeglicheTarifarten));
            }

            return cls.join(' ');
        }

        function getTarifartCls(tarifart) {
            var cls = [];

            cls.push('tarifart-' + _.toLower(tarifart));

            if (isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein'))) {
                cls.push('tarifart-aktiv');
            }

            if (_.size(vm.moeglicheTarifarten) === 3 || (_.size(vm.moeglicheTarifarten) === 0 && vm.defaultAnzahlMoeglicheTarifarten === 3)) {
                cls.push('small-4 medium-4 large-2');
            }
            if (_.size(vm.moeglicheTarifarten) === 2 || (_.size(vm.moeglicheTarifarten) === 0 && vm.defaultAnzahlMoeglicheTarifarten === 2)) {
                cls.push('small-6 medium-6 large-3');
            }
            if (_.size(vm.moeglicheTarifarten) === 1 || (_.size(vm.moeglicheTarifarten) === 0 && vm.defaultAnzahlMoeglicheTarifarten === 1)) {
                cls.push('large-6');
            }

            if (isTarifartEmpfehlungSichtbar(tarifart)) {
                cls.push('empfehlung');
            }

            if (isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein'))) {
                cls.push('tarifart-aktiv');
            }

            if (vm.disabled) {
                cls.push('disabled');
            }

            return cls.join(' ');
        }

        function getButtonCls(tarifart) {
            var cls = ['button select round center secondary'];

            if (isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein'))) {
                cls.push('active');
            }

            if (vm.disabled) {
                cls.push('disabled');
            }

            return cls.join(' ');
        }

        function onChangeTarifart(tarifart, bausteinKey) {
            if (vm.disabled) {
                return;
            }

            vm.bausteinTarifart = tarifart;

            vm.changeTarifart({
                tarifart: tarifart,
                bausteinKey: bausteinKey
            });
        }

        function isTarifartEmpfehlungSichtbar(tarifart) {
            return (
                tarifart === AppConfig.ANGEBOT.tarifartEmpfehlung &&
                _.size(vm.moeglicheTarifarten) > 1
            );
        }
    }

})();
